import React from 'react';
import { Box, CardContent, Typography, Divider } from '@mui/material';
import { TrendingUp as TrendingIcon } from '@mui/icons-material';
import { C, tRole } from './constants';
import { GlowCard, StatBar, roleIcon, roleColor } from './ui';

/**
 * StaffDistributionCard — role breakdown with mini bars + suspended count.
 *
 * Props:
 *   roleCounts — { [role]: count }
 *   suspended  — number of suspended members
 */
const StaffDistributionCard = ({ roleCounts, suspended, delay = 0 }) => {
  const maxCount = Math.max(...Object.values(roleCounts), 1);

  return (
    <GlowCard delay={delay} accent={C.accent} sx={{ height: '100%' }}>
      <CardContent sx={{ p: 3 }}>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2.5 }}>
          <TrendingIcon sx={{ color: C.accent, fontSize: 20 }} />
          <Typography sx={{ fontFamily: 'Syne', fontWeight: 700, color: C.text, fontSize: '1rem' }}>
            Répartition du staff
          </Typography>
        </Box>

        {Object.entries(roleCounts).map(([role, count], i) => {
          const color = roleColor(role);
          return (
            <Box
              key={role}
              sx={{ mb: 1.8, animation: `fadeUp 0.4s ease both`, animationDelay: `${i * 60 + delay}ms` }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.4 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, color }}>
                  {roleIcon(role)}
                  <Typography sx={{ fontFamily: 'DM Sans', color, fontSize: '0.78rem' }}>
                    {tRole(role)}
                  </Typography>
                </Box>
                <Typography sx={{ fontFamily: 'Syne', fontWeight: 700, color: C.text, fontSize: '0.85rem' }}>
                  {count}
                </Typography>
              </Box>
              <StatBar value={count} max={maxCount} color={color} />
            </Box>
          );
        })}

        {suspended > 0 && (
          <>
            <Divider sx={{ my: 2, borderColor: C.border }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography sx={{ fontFamily: 'DM Sans', color: C.rose, fontSize: '0.78rem' }}>
                ⚠ Suspendu{suspended > 1 ? 's' : ''}
              </Typography>
              <Typography sx={{ fontFamily: 'Syne', fontWeight: 700, color: C.rose, fontSize: '0.85rem' }}>
                {suspended}
              </Typography>
            </Box>
          </>
        )}

      </CardContent>
    </GlowCard>
  );
};

export default StaffDistributionCard;
